/* template */
import HomeTemplate from '../components/template/HomeTemplate'

const Home = () => {
  return (
    <HomeTemplate />
  )
}

export default Home